const React = require('react');
const Demo = require('../base-live-demo-component');
const componentCodeFront = require('./componentCodeFront');
const componentCodeBack = require('./componentCodeBack');
const View = require('./componentView');

const { useEffect } = React;
const componentProps = require('./componentProps');

const CheckoutProComponent = ({
  i18n,
  deviceType,
  lang,
  userData,
  platform,
  email,
  actualUrl,
  liveDemoId,
}) => {
  const customHook = ({ customVariables, customTexts, payerInfo, setFormData }) => {
    useEffect(() => {
      const customInputErrors = {
        customVariables: false,
        texts: false,
        payer: false,
      };

      try {
        JSON.parse(customVariables);
      } catch {
        customInputErrors.customVariables = {
          hasError: true,
          message: 'Revisa el formato de la configuración',
        };
      }

      try {
        JSON.parse(customTexts);
      } catch {
        customInputErrors.customTexts = {
          hasError: true,
          message: 'Revisa el formato de la configuración',
        };
      }

      try {
        JSON.parse(payerInfo);
      } catch {
        customInputErrors.payerInfo = {
          hasError: true,
          message: 'Revisa el formato de la configuración',
        };
      }

      setFormData(prev => ({
        ...prev,
        customErrors: {
          ...customInputErrors,
        },
      }));
    }, [
      customVariables,
      customTexts,
      payerInfo,
    ]);
  };

  const breadCrumbLevels = [
    {
      text: i18n.gettext('Documentación'),
      id: '1',
      href: `/developers/${lang}/docs`,
    },
    {
      text: i18n.gettext('Checkout Bricks'),
      id: '2',
      href: `/developers/${lang}/docs/checkout-bricks/landing`,
    },
    {
      text: i18n.gettext('Card Payment Brick'),
      id: '3',
      href: `/developers/${lang}/docs/checkout-bricks/card-payment-brick/introduction`,
    },
    {
      text: i18n.gettext('Demostración'),
      id: '4',
      disabled: true,
    },
  ];

  return (<Demo
    customHook={customHook}
    componentDemo={View}
    componentSnippetFront={componentCodeFront}
    componentSnippetBack={componentCodeBack}
    componentProps={componentProps.getProps(i18n, lang)}
    deviceType={deviceType}
    i18n={i18n}
    lang={lang}
    email={email}
    actualUrl={actualUrl}
    userData={userData}
    platform={platform}
    liveDemoId={liveDemoId}
    breadCrumbLevels={breadCrumbLevels}
  />);
};
module.exports = CheckoutProComponent;
